import { render, staticRenderFns } from "./goalManage.vue?vue&type=template&id=554ced39"
import script from "./goalManage.vue?vue&type=script&lang=js"
export * from "./goalManage.vue?vue&type=script&lang=js"
import style0 from "./goalManage.vue?vue&type=style&index=0&id=554ced39&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports